// material-ui
import { useTheme } from '@mui/material/styles';

// ==============================|| LOGO SVG ||============================== //
// DO-RA wordmark - fill="currentColor" in the source SVG (work/text_do-ra.svg)
// means it automatically follows text.primary in both light and dark mode.

export default function LogoMain() {
  const theme = useTheme();
  return (
    <svg
      width="118"
      height="24"
      viewBox="0 0 282 58"
      style={{ color: theme.vars.palette.text.primary }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(0.000000,58.000000) scale(0.100000,-0.100000)" stroke="none" fill="currentColor" fillRule="evenodd">
        <path d="M10 536 l0 -46 89 0 c78 0 95 -3 142 -28 77 -40 101 -84 97 -178 -6 -132 -68 -184 -230 -192 l-98 -5 0 -45 0 -45 113 5 c104 4 117 7 174 37 70 37 107 79 134 152 38 99 16 211 -57 289 -66 70 -125 93 -256 98 l-108 4 0 -46z" />
        <path d="M766 564 c-65 -20 -146 -101 -169 -168 -49 -142 6 -299 124 -358 30 -15 64 -30 77 -33 20 -6 22 -3 22 39 0 43 -2 47 -39 66 -73 37 -106 103 -99 200 5 72 41 131 98 160 38 19 40 23 40 65 0 25 -1 45 -2 44 -2 0 -25 -7 -52 -15z" />
        <path d="M910 530 c0 -37 4 -50 15 -50 24 0 87 -62 106 -105 46 -101 4 -232 -88 -270 -30 -13 -33 -18 -33 -59 l0 -45 45 14 c151 45 233 219 179 378 -23 69 -93 141 -160 166 -30 12 -57 21 -59 21 -3 0 -5 -22 -5 -50z" />
        <rect x="1330" y="250" width="150" height="90" />
        <path d="M1670 535 l0 -45 118 0 c194 -1 242 -20 242 -97 0 -85 -40 -103 -225 -103 l-135 0 0 -145 0 -145 50 0 50 0 0 100 0 100 63 0 63 0 69 -100 69 -100 59 0 c57 0 59 1 46 20 -8 11 -42 60 -77 110 l-63 90 28 11 c65 24 106 88 106 164 0 90 -53 155 -143 174 -28 6 -112 11 -185 11 l-135 0 0 -45z" />
        <path d="M2505 563 c4 -10 33 -92 65 -183 32 -91 77 -213 100 -272 l41 -108 54 0 54 0 -38 107 c-59 163 -158 436 -166 456 -6 13 -19 17 -62 17 -49 0 -54 -2 -48 -17z" />
        <path d="M2357 226 c-48 -118 -87 -218 -87 -221 0 -3 23 -5 52 -3 l52 3 61 150 62 150 -18 52 c-33 97 -29 101 -122 -131z" />
      </g>
    </svg>
  );
}
